import { defineMessages } from 'react-intl';

export default defineMessages({
	headline: {
		defaultMessage: 'Update your help center to the latest features',
		description:
			'Headline of the onboarding spotlight pointing existing admins at where they can update their help center.',
		id: 'avatar.menu.v2.update.help.center.spotlight.headline',
	},
	body: {
		defaultMessage: 'Use the update tool to convert your help center from here.',
		description:
			'Body of the onboarding spotlight pointing existing admins at where they can update their help center.',
		id: 'avatar.menu.v2.update.help.center.spotlight.body',
	},
	gotIt: {
		defaultMessage: 'Got it',
		description: 'Button that acknowledges and closes the Update help center onboarding spotlight.',
		id: 'avatar.menu.v2.update.help.center.spotlight.got.it',
	},
	dismiss: {
		defaultMessage: 'Dismiss',
		description:
			'Tooltip for the cross icon that closes the Update help center onboarding spotlight.',
		id: 'avatar.menu.v2.update.help.center.spotlight.dismiss',
	},
});
